"use strict";

exports.__esModule = true;
exports.DsDropDown = void 0;

require("core-js/modules/es.array.map.js");

var _react = _interopRequireDefault(require("react"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var DsDropDown = function DsDropDown(_ref) {
  var disabled = _ref.disabled,
      items = _ref.items,
      onChange = _ref.onChange,
      title = _ref.title,
      value = _ref.value,
      ariaLabel = _ref.ariaLabel;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("select", {
    className: 'form-select form-select-lg',
    onChange: onChange,
    disabled: disabled,
    defaultValue: value ? value : '',
    "aria-label": ariaLabel,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
      value: '',
      disabled: true,
      children: title
    }), items.map(function (item, index) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
        value: item.value,
        children: item.label
      }, index);
    })]
  });
};

exports.DsDropDown = DsDropDown;